export default function initAuthMenu() {
  try {
    const authMenuContainer = document.querySelector('#auth-menu');

    if (authMenuContainer !== null) {
      authMenuContainer.addEventListener('mouseenter', (e) => {
        const target = e.currentTarget;
        target.classList.remove('closed');
        target.classList.add('opened');
      });

      authMenuContainer.addEventListener('mouseleave', (e) => {
        const target = e.currentTarget;
        target.classList.remove('opened');
        target.classList.add('closed');
      });
    }
  } catch (e) {
    // eslint-disable-next-line
    console.warn(e);
  }
}
